import { createStore } from 'vuex';
import cartPreview from './store/cartPreview';
import form from './store/form';
import search from './store/search';
import storeSearch from './store/storeSearch';
import storeSelector from './store/storeSelector';
import wishlist from './store/wishlist';
import myAccountAddresses from './store/myAccountAddresses';
import myAccount from './store/myAccount';
import orders from './store/orders';
import checkout from './store/checkout';
import customerAddressForm from './store/customerAddressForm';
import currentUser from './store/currentUser';
import pspIframe from './store/pspIframe';
import sendPhoneTokenField from './store/sendPhoneTokenField';
import lightCheckout from './store/lightCheckout';
import strapSearch from './store/strapSearch';
import maisonModules from '@maison/store.js';

const store = createStore({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    cartPreview,
    form,
    search,
    storeSearch,
    storeSelector,
    myAccount,
    wishlist,
    orders,
    myAccountAddresses,
    checkout,
    customerAddressForm,
    currentUser,
    pspIframe,
    sendPhoneTokenField,
    lightCheckout,
    strapSearch,
    ...maisonModules,
  },
});

export default store;
